import styled, { css } from 'styled-components';
import { getColorForName } from '../../theme/colors';

// TODO: convert base Sass styles to styled-components
// TODO: create styled-compoennts styles to handle incoming props (like using theme colors)
// eslint-disable-next-line import/prefer-default-export
export const BaseFont = styled.h1`
  /* If a weight value was provided, override the default */
  ${({ weight }) => weight
    && css`
      && {
        font-weight: ${weight};
      }
    `} 
  /* If a color value was provided, override the default */
  ${({ color }) => color
    && css`
      && {
        color: ${getColorForName(color)};
      }
    `} 
  /* If a color value was provided, override the default */
  ${({ disableBottomPadding, as }) => {
    if (disableBottomPadding) return '';

    const componentWithPadding = as;
    let padding = '1rem'; // default

    if (componentWithPadding === 'h1') padding = '2rem';
    else if (componentWithPadding === 'h2') padding = '1.5rem';
    else if (componentWithPadding === 'h3') padding = '1.5rem';
    else if (componentWithPadding === 'h4') padding = '1.5rem';
    else if (componentWithPadding === 'h5') padding = '1.5rem';

    return css`
      && {
        padding-bottom: ${padding};
      }
    `;
  }}
`;
